export interface ConsumerPortalDemoEnvConfig {
	envName: string;
	production?: boolean;
	version?: string;
	apiUrl?: string;
	uiUrl: string;
	adminJSUrl? : string;
	loginApiUrl?: string;
	loginApiUrlInternal?: string;
	porPayScriptURL?: string;
	defaultSubDomain?: string;
	gapiApiBaseUrl: string;
}
